import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Table, Grid, Accordion, Icon } from "semantic-ui-react";
import SimpleSlider from "./slider";
import CountUp from "react-countup";
import CheckBox from "./checkbox";
import Undo from "./undo";
import { TextAligner } from "../helpers/text-aligner";
import translations from "../languages.json";
import { updateData, resetData, updateInitialData } from "../actions/actions-data";
import config from "../config.json";

class SelectionPane extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
    };

    state = { activeIndex: [0, 1, 2] };

    fn = (n) => {
        return n >= 0
            ? n.toLocaleString(this.props.language)
            : "- " + Math.abs(n).toLocaleString(this.props.language);
    };

    handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;

        if (activeIndex.indexOf(index) !== -1) {
            activeIndex.splice(activeIndex.indexOf(index), 1);
        } else {
            activeIndex.push(index);
        }

        let newIndex = activeIndex;
        this.setState({ activeIndex: newIndex });
    };

    render() {
        const { activeIndex } = this.state;
        const t = translations[this.props.language];
        const widths = {
            title: 2,
            center: {
                total: 8,
                text: 8,
                input: 8,
            },
            end: {
                total: 6,
                first: 5,
                second: 5,
                third: 6,
            },
        };

        return (
            <Accordion exclusive={false} fluid>
                <Accordion.Title
                    active={activeIndex.indexOf(0) !== -1}
                    index={0}
                    onClick={this.handleClick}
                    style={{ fontWeight: "bolder", fontSize: "1.2em" }}>
                    <Grid>
                        <Grid.Column width={widths.title + widths.center.total}>
                            <Icon name="dropdown" />
                            {t.financial_rent.title}
                        </Grid.Column>
                        <Grid.Column width={widths.end.total}>
                            {activeIndex.indexOf(0) !== -1 ? (
                                <Grid textAlign="center" style={{ paddingRight: "15px" }}>
                                    <Grid.Column width={widths.end.first}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>
                                            {t.chart.after}
                                        </p>
                                    </Grid.Column>
                                    <Grid.Column width={widths.end.second}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>
                                            {t.chart.before}
                                        </p>
                                    </Grid.Column>
                                    <Grid.Column width={widths.end.third}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>Variation</p>
                                    </Grid.Column>
                                </Grid>
                            ) : null}
                        </Grid.Column>
                    </Grid>
                </Accordion.Title>
                <Accordion.Content active={activeIndex.indexOf(0) !== -1}>
                    <Table attached="top" compact="very" singleLine color="blue">
                        <Table.Header />
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell rowSpan={4} width={widths.title - 1}>
                                    {t.financial_rent.price.title}
                                </Table.Cell>
                                <Table.Cell width={widths.center.total + 1}>
                                    <p>{t.financial_rent.price.raw_price}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.fn(this.props.data.raw_initial_price),
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.raw_initial_price),
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third} />
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.center.total + 1}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text}>
                                            <p>
                                                <Undo target="rebate" action={this.props.resetData} />
                                                {t.financial_rent.price.rebate}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column width={Math.floor(((16 - widths.center.input) * 2) / 3)}>
                                            <SimpleSlider
                                                action={this.props.updateData}
                                                target={"rebate"}
                                                init={this.props.data.rebate}
                                                min={config.rebate_min}
                                                max={config.rebate_max}
                                                step={config.rebate_step}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={Math.ceil(((16 - widths.center.input) * 1) / 3)}>
                                            <p style={{ textAlign: "right" }}>
                                                - {this.props.data.rebate.toLocaleString(this.props.language)}{" "}
                                                %
                                            </p>
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.fn(
                                                    this.props.data.raw_initial_price *
                                                        (-this.props.data.rebate / 100)
                                                ),
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(
                                                    this.props.parameters.raw_initial_price *
                                                        (-this.props.parameters.rebate / 100)
                                                ),
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.data.rebate >= this.props.parameters.rebate
                                                    ? "+ "
                                                    : " ") +
                                                    this.fn(
                                                        this.props.data.rebate - this.props.parameters.rebate
                                                    ),
                                                "pts"
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.center.total + 1}>
                                    <p>{t.financial_rent.price.vat}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(this.fn(this.props.data.vat), t.parameters.money)}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.vat),
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                this.props.data.vat - this.props.parameters.vat === 0 ? "+ 0" : 
                                                (this.props.data.vat >= this.props.parameters.vat ? "+ " : "") + this.fn(Math.round(
                                                    ((this.props.data.vat - this.props.parameters.vat) /
                                                        this.props.parameters.vat)
                                                 * 100)),
                                                "%"
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell witdh={widths.center.total + 1}>
                                    <p>{t.financial_rent.price.net_discounted_price}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.fn(this.props.data.net_discounted_price),
                                                t.parameters.money,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.net_discounted_price),
                                                t.parameters.money,
                                                true,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.data.net_discounted_price >=
                                                this.props.parameters.net_discounted_price
                                                    ? "+ "
                                                    : " ") +
                                                    this.fn(
                                                        Math.round(
                                                            ((this.props.data.net_discounted_price -
                                                                this.props.parameters.net_discounted_price) /
                                                                this.props.parameters.net_discounted_price) *
                                                                100
                                                        )
                                                    ),
                                                "%",
                                                true
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell rowSpan={4} width={widths.title - 1}>
                                    {t.financial_rent.contract.title}
                                </Table.Cell>
                                <Table.Cell width={widths.center.total + 1}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text}>
                                            <p>
                                                <Undo target="duration" action={this.props.resetData} />
                                                {t.financial_rent.contract.duration}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column width={widths.center.input}>
                                            <SimpleSlider
                                                action={this.props.updateData}
                                                target={"duration"}
                                                init={this.props.data.duration}
                                                min={config.duration_min}
                                                max={config.duration_max}
                                                step={config.duration_step}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.fn(this.props.data.duration),
                                                t.financial_rent.contract.months
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.duration),
                                                t.financial_rent.contract.months,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.data.duration >= this.props.parameters.duration
                                                    ? "+ "
                                                    : " ") +
                                                    this.fn(
                                                        this.props.data.duration -
                                                            this.props.parameters.duration
                                                    ),
                                                t.financial_rent.contract.months,
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.center.total + 1}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text}>
                                            <p>
                                                <Undo target="mileage" action={this.props.resetData} />
                                                {t.financial_rent.contract.mileage}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column width={widths.center.input}>
                                            <SimpleSlider
                                                action={this.props.updateData}
                                                target={"mileage"}
                                                init={this.props.data.mileage}
                                                min={config.mileage_min}
                                                max={config.mileage_max}
                                                step={config.mileage_step}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(this.fn(this.props.data.mileage), "km")}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.mileage),
                                                "km",
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.parameters.mileage <= this.props.data.mileage
                                                    ? "+ "
                                                    : " ") +
                                                    this.fn(
                                                        this.props.data.mileage -
                                                            this.props.parameters.mileage
                                                    ),
                                                "km"
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.center.total + 1}>
                                    <p>{t.financial_rent.contract.residual_value}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.fn(this.props.data.residual_value),
                                                t.parameters.money,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.residual_value),
                                                t.parameters.money,
                                                true,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.parameters.residual_value <=
                                                this.props.data.residual_value
                                                    ? "+ "
                                                    : " ") +
                                                    this.fn(
                                                        Math.round(
                                                            ((this.props.data.residual_value -
                                                                this.props.parameters.residual_value) /
                                                                this.props.parameters.residual_value) *
                                                                100
                                                        )
                                                    ),
                                                "%",
                                                true,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.center.total + 1}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text}>
                                            <p>
                                                <Undo target="interest_rate" action={this.props.resetData} />
                                                {t.financial_rent.interest.interest_rate}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column width={widths.center.input}>
                                            <SimpleSlider
                                                action={this.props.updateData}
                                                target={"interest_rate"}
                                                init={this.props.data.interest_rate}
                                                max={20}
                                                step={0.1}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(this.fn(this.props.data.interest_rate), "%")}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.parameters.interest_rate),
                                                "%",
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.data.interest_rate >=
                                                this.props.parameters.interest_rate
                                                    ? "+ "
                                                    : " ") +
                                                    this.fn(
                                                        Math.round(
                                                            (this.props.data.interest_rate -
                                                                this.props.parameters.interest_rate) *
                                                                100
                                                        ) / 100
                                                    ),
                                                "pts"
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    <Table attached="bottom" singleLine compact="very">
                        <Table.Body>
                            <Table.Row active>
                                <Table.Cell width={widths.title + widths.center.total}>
                                    <strong>{t.financial_rent.total}</strong> ({Math.round(
                                        (100 * this.props.tco.financial_rent) /
                                            (this.props.tco.financial_rent +
                                                this.props.tco.company_tco +
                                                this.props.tco.vehicle_tco)
                                    )}% {t.parameters.of_total})
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first} textAlign="right">
                                            <strong>
                                                <CountUp
                                                    start={300}
                                                    end={this.props.tco.financial_rent}
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix=" "
                                                    suffix={" " + t.parameters.money}
                                                    redraw={true}
                                                />
                                                &nbsp; ({
                                                    <CountUp
                                                        start={300}
                                                        end={
                                                            this.props.tco.financial_rent -
                                                            this.props.initial_tco.initial_financial_rent
                                                        }
                                                        duration={0.5}
                                                        useEasing={true}
                                                        separator={
                                                            this.props.language === "en-gb" ? "," : " "
                                                        }
                                                        prefix={
                                                            this.props.tco.financial_rent >=
                                                            this.props.initial_tco.initial_financial_rent
                                                                ? "+ "
                                                                : " "
                                                        }
                                                        suffix={" " + t.parameters.money}
                                                        redraw={true}
                                                    />
                                                })
                                            </strong>
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.initial_tco.initial_financial_rent),
                                                t.parameters.money,
                                                true,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                <CountUp
                                                    start={300}
                                                    end={
                                                        (100 *
                                                            (this.props.tco.financial_rent -
                                                                this.props.initial_tco
                                                                    .initial_financial_rent)) /
                                                        this.props.initial_tco.initial_financial_rent
                                                    }
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix={
                                                        this.props.tco.financial_rent >=
                                                        this.props.initial_tco.initial_financial_rent
                                                            ? "+ "
                                                            : " "
                                                    }
                                                    suffix={""}
                                                    redraw={true}
                                                />,
                                                "%",
                                                true
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Accordion.Content>

                <Accordion.Title
                    active={activeIndex.indexOf(1) !== -1}
                    index={1}
                    onClick={this.handleClick}
                    style={{ fontWeight: "bolder", fontSize: "1.2em" }}>
                    <Grid>
                        <Grid.Column width={widths.title + widths.center.total}>
                            <Icon name="dropdown" />
                            {t.vehicle_tco.title}
                        </Grid.Column>
                        <Grid.Column width={widths.end.total}>
                            {activeIndex.indexOf(1) !== -1 ? (
                                <Grid textAlign="center" style={{ paddingRight: "15px" }}>
                                    <Grid.Column width={widths.end.first}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>
                                            {t.chart.after}
                                        </p>
                                    </Grid.Column>
                                    <Grid.Column width={widths.end.second}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>
                                            {t.chart.before}
                                        </p>
                                    </Grid.Column>
                                    <Grid.Column width={widths.end.third}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>Variation</p>
                                    </Grid.Column>
                                </Grid>
                            ) : null}
                        </Grid.Column>
                    </Grid>
                </Accordion.Title>
                <Accordion.Content active={activeIndex.indexOf(1) !== -1}>
                    <Table attached="top" compact="very" singleLine color="orange">
                        <Table.Header />
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>{t.vehicle_tco.maintenance_repair}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <CheckBox
                                                action={this.props.updateData}
                                                target="has_maintenance"
                                                checked={this.props.data.has_maintenance}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.props.data.has_maintenance
                                                    ? this.fn(this.props.data.maintenance)
                                                    : "0",
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.has_maintenance
                                                    ? this.fn(this.props.parameters.maintenance)
                                                    : "0",
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                this.props.data.has_maintenance
                                                    ? (this.props.data.maintenance >=
                                                      this.props.parameters.maintenance
                                                          ? "+ "
                                                          : "") +
                                                      this.fn(
                                                          Math.round(
                                                              (100 *
                                                                  (this.props.data.maintenance -
                                                                      this.props.parameters.maintenance)) /
                                                                  this.props.parameters.maintenance
                                                          )
                                                      )
                                                    : this.fn(-100),
                                                "%",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>{t.vehicle_tco.assistance}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <CheckBox
                                                action={this.props.updateData}
                                                target="has_assistance"
                                                checked={this.props.data.has_assistance}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.props.data.has_assistance
                                                    ? this.fn(this.props.data.assistance)
                                                    : "0",
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.has_assistance
                                                    ? this.fn(this.props.parameters.assistance)
                                                    : "0",
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                this.props.data.has_assistance
                                                    ? (this.props.data.assistance >=
                                                      this.props.parameters.assistance
                                                          ? "+ "
                                                          : "") +
                                                      this.fn(
                                                          Math.round(
                                                              (100 *
                                                                  (this.props.data.assistance -
                                                                      this.props.parameters.assistance)) /
                                                                  this.props.parameters.assistance
                                                          )
                                                      )
                                                    : this.fn(-100),
                                                "%",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>{t.vehicle_tco.tires}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <CheckBox
                                                action={this.props.updateData}
                                                target="has_tires"
                                                checked={this.props.data.has_tires}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.props.data.has_tires
                                                    ? this.fn(this.props.data.tires)
                                                    : "0",
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.has_tires
                                                    ? this.fn(this.props.parameters.tires)
                                                    : "0",
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                this.props.data.has_tires
                                                    ? (this.props.data.tires >= this.props.parameters.tires
                                                          ? "+ "
                                                          : "") +
                                                      this.fn(
                                                          Math.round(
                                                              (100 *
                                                                  (this.props.data.tires -
                                                                      this.props.parameters.tires)) /
                                                                  this.props.parameters.tires
                                                          )
                                                      )
                                                    : this.fn(-100),
                                                "%",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>{t.vehicle_tco.insurance}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid>
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <CheckBox
                                                action={this.props.updateData}
                                                target="has_insurance"
                                                checked={this.props.data.has_insurance}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.props.data.has_insurance
                                                    ? this.fn(this.props.data.insurance)
                                                    : "0",
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.has_insurance
                                                    ? this.fn(this.props.parameters.insurance)
                                                    : "0",
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                this.props.data.has_insurance
                                                    ? (this.props.data.insurance >=
                                                      this.props.parameters.insurance
                                                          ? "+ "
                                                          : "") +
                                                      this.fn(
                                                          Math.round(
                                                              (100 *
                                                                  (this.props.data.insurance -
                                                                      this.props.parameters.insurance)) /
                                                                  this.props.parameters.insurance
                                                          )
                                                      )
                                                    : this.fn(-100),
                                                "%",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    <Table attached="bottom" singleLine compact="very">
                        <Table.Body>
                            <Table.Row active>
                                <Table.Cell width={widths.title + widths.center.total}>
                                    <strong>{t.vehicle_tco.total}</strong> ({Math.round(
                                        (100 * this.props.tco.vehicle_tco) /
                                            (this.props.tco.financial_rent +
                                                this.props.tco.company_tco +
                                                this.props.tco.vehicle_tco)
                                    )}% {t.parameters.of_total})
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first} textAlign="right">
                                            <strong>
                                                <CountUp
                                                    start={300}
                                                    end={this.props.tco.vehicle_tco}
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix=" "
                                                    suffix={" " + t.parameters.money}
                                                    redraw={true}
                                                />
                                                &nbsp; (
                                                <CountUp
                                                    start={300}
                                                    end={
                                                        this.props.tco.vehicle_tco -
                                                        this.props.initial_tco.initial_vehicle_tco
                                                    }
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix={
                                                        this.props.tco.vehicle_tco >=
                                                        this.props.initial_tco.initial_vehicle_tco
                                                            ? "+ "
                                                            : " "
                                                    }
                                                    suffix={" " + t.parameters.money}
                                                    redraw={true}
                                                />
                                                )
                                            </strong>
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.initial_tco.initial_vehicle_tco.toLocaleString(
                                                    this.props.language
                                                ),
                                                t.parameters.money,
                                                true,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                <CountUp
                                                    start={300}
                                                    end={
                                                        (100 *
                                                            (this.props.tco.vehicle_tco -
                                                                this.props.initial_tco.initial_vehicle_tco)) /
                                                        this.props.initial_tco.initial_vehicle_tco
                                                    }
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix={
                                                        this.props.tco.vehicle_tco >=
                                                        this.props.initial_tco.initial_vehicle_tco
                                                            ? "+ "
                                                            : " "
                                                    }
                                                    redraw={true}
                                                />,
                                                "%",
                                                true
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Accordion.Content>

                <Accordion.Title
                    active={activeIndex.indexOf(2) !== -1}
                    index={2}
                    onClick={this.handleClick}
                    style={{ fontWeight: "bolder", fontSize: "1.2em" }}>
                    <Grid>
                        <Grid.Column width={widths.title + widths.center.total}>
                            <Icon name="dropdown" />
                            {t.company_tco.title}
                        </Grid.Column>
                        <Grid.Column width={widths.end.total}>
                            {activeIndex.indexOf(2) !== -1 ? (
                                <Grid textAlign="center" style={{ paddingRight: "15px" }}>
                                    <Grid.Column width={widths.end.first}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>
                                            {t.chart.after}
                                        </p>
                                    </Grid.Column>
                                    <Grid.Column width={widths.end.second}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>
                                            {t.chart.before}
                                        </p>
                                    </Grid.Column>
                                    <Grid.Column width={widths.end.third}>
                                        <p style={{ fontWeight: "normal", fontSize: "0.9em" }}>Variation</p>
                                    </Grid.Column>
                                </Grid>
                            ) : null}
                        </Grid.Column>
                    </Grid>
                </Accordion.Title>
                <Accordion.Content active={activeIndex.indexOf(2) !== -1}>
                    <Table attached="top" compact="very" singleLine color="green">
                        <Table.Header />
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>{t.company_tco.fuel}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <CheckBox
                                                action={this.props.updateData}
                                                target="has_fuel"
                                                checked={this.props.data.has_fuel}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.props.data.has_fuel
                                                    ? this.fn(
                                                          Math.round(
                                                              (this.props.data.fuel_price *
                                                                  this.props.data.total_consumption) /
                                                                  this.props.data.duration
                                                          )
                                                      )
                                                    : 0,
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.has_fuel
                                                    ? this.fn(
                                                          Math.round(
                                                              (this.props.parameters.fuel_price *
                                                                  this.props.parameters.total_consumption) /
                                                                  this.props.parameters.duration
                                                          )
                                                      )
                                                    : 0,
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                ((this.props.data.fuel_price *
                                                    this.props.data.total_consumption) /
                                                    this.props.data.duration >=
                                                    (this.props.parameters.fuel_price *
                                                        this.props.parameters.total_consumption) /
                                                        this.props.parameters.duration &&
                                                this.props.data.has_fuel
                                                    ? "+ "
                                                    : "") +
                                                    (this.props.data.has_fuel
                                                        ? this.fn(
                                                              Math.round(
                                                                  (100 *
                                                                      ((this.props.data.fuel_price *
                                                                          this.props.data.total_consumption) /
                                                                          this.props.data.duration -
                                                                          (this.props.parameters.fuel_price *
                                                                              this.props.parameters
                                                                                  .total_consumption) /
                                                                              this.props.parameters
                                                                                  .duration)) /
                                                                      ((this.props.parameters.fuel_price *
                                                                          this.props.parameters
                                                                              .total_consumption) /
                                                                          this.props.parameters.duration)
                                                              )
                                                          )
                                                        : this.fn(-100)),
                                                "%",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>{t.company_tco.taxes}</p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <CheckBox
                                                action={this.props.updateData}
                                                target="has_taxes"
                                                checked={this.props.data.has_taxes}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(
                                                this.props.data.has_taxes
                                                    ? this.fn(this.props.tco.taxes_amount)
                                                    : 0,
                                                t.parameters.money
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.has_taxes
                                                    ? this.fn(this.props.initial_tco.initial_taxes_amount)
                                                    : 0,
                                                t.parameters.money,
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.tco.taxes_amount >=
                                                this.props.initial_tco.initial_taxes_amount
                                                    ? "+ "
                                                    : "") +
                                                    this.fn(
                                                        Math.round(
                                                            (100 *
                                                                (this.props.tco.taxes_amount -
                                                                    this.props.initial_tco
                                                                        .initial_taxes_amount)) /
                                                                this.props.initial_tco.initial_taxes_amount
                                                        )
                                                    ),
                                                "%",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={widths.title}>
                                    <p>
                                        <Undo target="co2_emissions" action={this.props.resetData} />
                                        {t.company_tco.co2}
                                    </p>
                                </Table.Cell>
                                <Table.Cell width={widths.center.total}>
                                    <Grid verticalAlign="middle">
                                        <Grid.Column width={widths.center.text} />
                                        <Grid.Column width={widths.center.input}>
                                            <SimpleSlider
                                                init={this.props.data.co2_emissions}
                                                min={0}
                                                max={300}
                                                step={1}
                                                action={this.props.updateData}
                                                target={"co2_emissions"}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first}>
                                            {TextAligner(this.props.data.co2_emissions, "g/km")}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.props.parameters.co2_emissions,
                                                "g/km",
                                                false,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                (this.props.data.co2_emissions >=
                                                this.props.parameters.co2_emissions
                                                    ? "+ "
                                                    : "") +
                                                    this.fn(
                                                        this.props.data.co2_emissions -
                                                            this.props.parameters.co2_emissions
                                                    ),
                                                "g/km",
                                                false,
                                                false
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    <Table attached="bottom" singleLine compact="very">
                        <Table.Body>
                            <Table.Row active>
                                <Table.Cell width={widths.title + widths.center.total}>
                                    <strong>{t.company_tco.total}</strong> ({this.fn(
                                        Math.round(
                                            (100 * this.props.tco.company_tco) /
                                                (this.props.tco.financial_rent +
                                                    this.props.tco.company_tco +
                                                    this.props.tco.vehicle_tco)
                                        )
                                    )}% {t.parameters.of_total})
                                </Table.Cell>
                                <Table.Cell width={widths.end.total}>
                                    <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                        <Grid.Column width={widths.end.first} textAlign="right">
                                            <strong>
                                                <CountUp
                                                    start={300}
                                                    end={this.props.tco.company_tco}
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix=" "
                                                    suffix={" " + t.parameters.money}
                                                    redraw={true}
                                                />
                                                &nbsp; ({
                                                    <CountUp
                                                        start={300}
                                                        end={
                                                            this.props.tco.company_tco -
                                                            this.props.initial_tco.initial_company_tco
                                                        }
                                                        duration={0.5}
                                                        useEasing={true}
                                                        separator={
                                                            this.props.language === "en-gb" ? "," : " "
                                                        }
                                                        prefix={
                                                            this.props.tco.company_tco >=
                                                            this.props.initial_tco.initial_company_tco
                                                                ? "+ "
                                                                : " "
                                                        }
                                                        suffix={" " + t.parameters.money}
                                                        redraw={true}
                                                    />
                                                })
                                            </strong>
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.second}>
                                            {TextAligner(
                                                this.fn(this.props.initial_tco.initial_company_tco),
                                                t.parameters.money,
                                                true,
                                                true
                                            )}
                                        </Grid.Column>
                                        <Grid.Column width={widths.end.third}>
                                            {TextAligner(
                                                <CountUp
                                                    start={300}
                                                    end={
                                                        (100 *
                                                            (this.props.tco.company_tco -
                                                                this.props.initial_tco.initial_company_tco)) /
                                                        this.props.initial_tco.initial_company_tco
                                                    }
                                                    duration={0.5}
                                                    useEasing={true}
                                                    separator={this.props.language === "en-gb" ? "," : " "}
                                                    prefix={
                                                        this.props.tco.company_tco >=
                                                        this.props.initial_tco.initial_company_tco
                                                            ? "+ "
                                                            : " "
                                                    }
                                                    redraw={true}
                                                />,
                                                "%",
                                                true
                                            )}
                                        </Grid.Column>
                                    </Grid>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Accordion.Content>
            </Accordion>
        );
    }
}

function mapStateToProps(state) {
    return {
        data: state.reducerData,
        parameters: state.reducerParameters,
        tco: state.reducerTco,
        initial_tco: state.reducerInitialTco,
        language: state.reducerLanguage,
    };
}

export default connect(
    mapStateToProps,
    { updateData, updateInitialData, resetData }
)(SelectionPane);



// WEBPACK FOOTER //
// ./src/components/selection-pane.js